import { connect } from 'react-redux';
import { StoreState } from '../../reducers';
import Breadcrumbs from '../../components/Breadcrumbs';
import Utils from '../../utils';
import DriveItemUtils from '../../utils/driveItem';

const mapStateToProps = (state: StoreState) => {
	const { driveList, galleryInfos, routerParamsHistory } = state;
	const { config, config: { applicationGallery: galleryId }, config: { breadcrumbs: isCustomHomeLink = false } } = galleryInfos;
	const { driveItems, isEditMode } = driveList;
	const sharedDirId = Utils.getSharedDirId(driveList, config);
	const archiveDirId = Utils.getArchiveDirId(driveList, config);
	const currentFolderId = Utils.getCurrentFolderId(galleryId, routerParamsHistory);

	return {
		galleryId,
		sharedDirId,
		currentFolderId,
		driveItems,
		archiveDirId,
		isEditMode,
		isFolderEditable: (folderId: number) => DriveItemUtils.isFolderEditableForCurrentUser(folderId, state),
		isCustomHomeLink
	};
};

export default connect(mapStateToProps)(Breadcrumbs);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Breadcrumbs/index.tsx